<template>
  <div
    style="
      background: #f5f5f5;
      background-image: url('../../../static/img/Background4.jpg');
      background-repeat: round;
    "
  >
    <div class="father_div_bg">
      <div class="selectbox">
        <img src="../../../static/img/48.png" class="jiantou" />
        <span>{{ language == "zh" ? "产品中心" : "Products" }}</span>
        <transition
          appear
          name="animate__animated animate__bounce"
          enter-active-class="animate__fadeIn"
          leave-active-class="animated__fadeOut"
        >
          <div v-show="isShow" class="keyinput">
            <el-autocomplete
              class="inline-input"
              v-model="input"
              :fetch-suggestions="querySearch"
              :placeholder="language=='zh'?'请输入内容':'please input'"
              style="width: 300px"
              @select="handleSelect"
              :trigger-on-focus="false"
            ></el-autocomplete>
          </div>
        </transition>
        <img
          src="../../../static/img/5.png"
          class="sousuo"
          @click="isShow = !isShow"
        />
      </div>
      <el-row :gutter="25" class="product-menu">
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="left">
          <div class="menu">
            <el-tree
              class="tree treea"
              :icon-class="icon"
              :default-expand-all="true"
              :data="menu"
              :props="defaultProps"
              @node-click="handleNodeClick"
              v-show="language == 'zh'"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span :class="node.disabled?'p_disabled':'p_abled'">{{ node.label }}</span>
              </span>
            </el-tree>
            <el-tree
              class="tree treea"
              :icon-class="icon"
              :default-expand-all="true"
              :data="menu1"
              :props="defaultProps1"
              @node-click="handleNodeClick"
              v-show="language == 'en'"
            >
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span :class="node.disabled?'p_disabled':'p_abled'">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <div class="menu callus show_pc">
            <div class="text">
              {{ language == "zh" ? "联系我们" : "Contact us" }}
            </div>
            <div class="tel">
              <img src="../../../static/img/50.png" /> {{ contact.tel }}
            </div>
            <div class="email">
              <img src="../../../static/img/49.png" />{{ contact.email }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="right">
          <el-row :gutter="25">
            <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="8"
              class="item"
              v-for="(item, i) in menu"
              :key="i"
            >
              <img :src="item.pic" class="item-img" />
              <div class="name">
                <p>
                  {{ language == "zh" ? item.label : item.labelEn }}
                </p>
              </div>
              <div class="zhezhao">
                <div
                  class="title"
                  :class="item.disabled ? 'disabled' : ''"
                  @click="item.disabled ? '' : navto(item.value, null)"
                >
                  {{ language == "zh" ? item.label : item.labelEn }}
                </div>
                <div class="heng"></div>
                <div
                  class="item"
                  :class="items.disabled ? 'disabled' : ''"
                  v-for="(items, ins) in item.children"
                  :key="ins"
                  @click="gotonext(item, items)"
                >
                  {{ language == "zh" ? items.label : items.labelEn }}
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="Mymenu callus show_phone">
          <div class="text">
            {{language=='zh'?'联系我们':'Contact us'}}
          </div>
          <div class="tel">
           <img src="../../../static/img/50.png" /> {{contact.tel}}
          </div>
          <div class="email">
            <img src="../../../static/img/49.png" />{{contact.email}}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "Product",
  data() {
    return {
      isShow: false,
      input: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      defaultProps1: {
        children: "children",
        label: "labelEn",
      },
      contact: {},
      icon: "el-icon-plus",
      menu: [],
      menu1: [],
      restaurants: [],
    };
  },
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.input = '';
      this.getInfo();
      this.getInfo1();
      if (this.GetQueryString("isshow")) {
        this.isShow = true;
      }
      // this.$parent.hideSearch = from.fullPath.indexOf('Product') >= 0?true:false
    },
  },
  mounted() {
    this.getInfo();
    this.getInfo1();
    // this.$parent.hideSearch = false
    if (this.GetQueryString("isshow")) {
      this.isShow = true;
    }
  },
  methods: {
    querySearch(queryString, cb) {
      let params = {
        key: this.input,
        page: 1,
        limit: 999,
      };
      this.$http
        .get("/hdbs/api/product/list", {
          params,
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              let restaurant = [];
              let temp_arr = [];
              response.data.data.list.map((data) => {
                // let list1 = this.menu.filter(c=>{return c.value == data.type1})[0]
                // console.log(list1)
                // if(data.type1 && list1){
                //   restaurant.push({value:list1.label,code:1,id:data.type1})
                // }
                // let list2 = list1.children || [].filter(c=>{return c.value == data.type2})
                //   console.log(list2)
                // let list3 = list2[0].children || [].filter(c=>{return c.value == data.type3})
                //   console.log(list3)
                // if(data.type2 && list2.length > 0){
                //     let d = list1.label + '>' + list2[0].label
                //     restaurant.push({value:d,code:2,id:data.type2,pid:data.type1})
                // }
                // if(list3.length > 0 && data.type3){
                //     let d = list1.label + '>' + list2[0].label + '>' + list3[0].label
                //     restaurant.push({value:d,code:3,id:data.type2,pid:data.type1})
                //   }
                // restaurant.push({value:data.key +'('+data.model+')',code:4,id:data.id})
                var typeNameList = data.typeName.split("/");
                var typeNameListEn = data.typeNameEn.split("/");
                console.log(typeNameList);
                if (data.type1) {
                  let d = typeNameList[0];
                  if(this.language=='en'){
                   d = typeNameListEn[0];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({ value: d, code: 1, type1: data.type1 });
                  }
                }
                if (data.type2) {
                  let d = typeNameList[0] + ">" + typeNameList[1];
                  if(this.language=='en'){
                   d = typeNameListEn[0] + ">" + typeNameListEn[1];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({
                      value: d,
                      code: 2,
                      type1: data.type1,
                      type2: data.type2,
                    });
                  }
                }
                if (data.type3) {
                  let d =
                    typeNameList[0] +
                    ">" +
                    typeNameList[1] +
                    ">" +
                    typeNameList[2];
                  if(this.language=='en'){
                    d =
                    typeNameListEn[0] +
                    ">" +
                    typeNameListEn[1] +
                    ">" +
                    typeNameListEn[2];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({
                      value: d,
                      code: 3,
                      type1: data.type1,
                      type2: data.type2,
                      type3: data.type3,
                    });
                  }
                }
                  let d = data.key + "(" + data.model + ")";
                  if(this.language=='en'){
                   d = data.keyEn + "(" + data.model + ")";
                  }
                restaurant.push({
                  value: d,
                  code: 4,
                  id: data.id,
                });
              });
              // 调用 callback 返回建议列表的数据
              cb(restaurant);
            }
          }.bind(this)
        );
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getInfo() {
      this.$http.get("/hdbs/api/product/type/tree", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.menu = response.data.data;
            this.menu.map((r) => {
              r.level = 1;
              if (!r.children && r.num == 0) {
                r.disabled = true;
                return false;
              }
              if (r.children) {
                r.children.map((c) => {
                  c.level = 2;
                  if (c.num == 0) {
                    c.disabled = true;
                    if (c.children) {
                      c.children.map((a) => {
                        a.level = 3;
                        a.disabled = true;
                      });
                    }
                  } else {
                    if (c.children) {
                      c.children.map((a) => {
                        a.level = 3;
                        a.type1 = r.value;
                        if (a.num == 0) {
                          a.disabled = true;
                        }
                      });
                    }
                  }
                });
              }
            });
            this.menu1 = this.menu;
          }
        }.bind(this)
      );
    },
    getInfo1() {
      this.$http.get("/hdbs/api/contacts/company", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.contact = response.data.data[0];
          }
        }.bind(this)
      );
    },
    handleSelect(item) {
      console.log(item);
      // if(item.code == 2 || item.code == 3){
      //   this.navto(item.id,item.pid)
      // }else
      if (item.code == 4) {
        this.$router.push("/ProductIntroduce?id=" + item.id);
      } else if (item.code == 1) {
        this.$router.push("/ProductDetail?type1=" + item.type1);
      } else if (item.code == 2) {
        this.$router.push(
          "/ProductDetail?type1=" + item.type1 + "&type2=" + item.type2
        );
      } else if (item.code == 3) {
        this.$router.push(
          "/ProductDetail?type1=" +
            item.type1 +
            "&type2=" +
            item.type2 +
            "&type3=" +
            item.type3
        );
      }
    },
    handleNodeClick(data) {
      if (data.level == 1 && !data.disabled) {
        this.$router.push("/ProductDetail?type1=" + data.value);
      } else if (data.level == 2 && !data.disabled) {
        this.$router.push(
          "/ProductDetail?type1=" + data.parentId + "&type2=" + data.value
        );
      } else if (data.level == 3 && !data.disabled) {
        this.$router.push(
          "/ProductDetail?type1=" +
            data.type1 +
            "&type2=" +
            data.parentId +
            "&type3=" +
            data.value
        );
      }
    },
    gotonext(item, items) {
      if (items.disabled === true) {
        return;
      }
      this.navto(item.value, items.value);
    },
    navto(id1, id2) {
      this.$router.push("/ProductDetail?type1=" + id1 + (id2?"&type2=" +id2:"" ));
    },
  },
};
</script>
<style lang="stylus" scoped>
.Mymenu{
  width: 100%;
  padding: 3.5rem 2rem;
  background: #fff;
  border-radius: 6px;
  font-size: 1.7rem;
  margin-bottom: 3rem;
  box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
    .biaoti{
      color: var(--mainBlue);
      margin-bottom: 3rem;
      font-size: 2.7rem;
      margin-left: 2.5rem;
      font-family: Demibold;
    }
}
.show_pc {
  display: block;
}
.show_phone {
  display: none;
}
.selectbox {
  background: #fff;
  border-radius: 6px;
  margin: 4vh 0;
  padding: 2rem;
  position: relative;
  font-family: Regular;
  display: flex;
  color: var(--mainGary);
  font-size: 1.7rem;
  align-items: center;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);

  .jiantou {
    width: 6px;
    margin-right: 20px;
  }

  .sousuo {
    width: 15px;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }

  .keyinput {
    position: absolute;
    right: 10px;

    /deep/.el-input__inner {
      width: 300px;
    }
  }
}

.callus {
  margin-top: 3rem;
  padding: 3.5rem 2rem;
  font-size: 1.7rem;

  .text {
    color: #024580;
    margin-bottom: 2rem;
    margin-left: 2.5rem;
  }

  .tel {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }

  .email {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }
}

.product-menu {
  margin: 0 !important;

  .left {
    padding-left: 0 !important;

    .menu {
      background: #fff;
      border-radius: 6px;
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
      margin-bottom: 25px;

      .tree {
        border-radius: 6px;
        padding: 1vw;
        font-family: Regular;
      }
    }
  }

  .right {
    .item {
      margin-bottom: 25px;
      position: relative;
      color: var(--mainGary);
      transition: all 0.3s;

      .zhezhao {
        opacity: 0;
        transition: all 0.3s;
        position: absolute;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.6) 60%, rgba(255, 255, 255, 1));
        top: 0;
        width: calc(100% - 25px);
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 2rem 0;
        color: #606266;

        .title {
          font-size: 2.1rem;
          font-family: Demibold;
          cursor: pointer;
        }

        .title:hover {
          color:var(--mainBlue)
        }

        .item {
          font-size: 1.7rem;
          font-family: Regular;
          margin: 1rem 0;
          line-height: 15px;
          cursor: pointer;
        }

        .heng {
          height: 1.5px;
          width: 50%;
          background: #555555;
          margin: 10px 0;
          margin-left: 25%;
        }
      }

      .item.disabled {
        font-family: Regular;
        color: #72717180;
        cursor: not-allowed;
      }

      .title.disabled {
        font-size: 2.1rem;
        color: #72717180;
        font-family: Demibold;
        cursor: not-allowed;
      }

      .item-img {
        width: 100%;
        height: 26rem;
        object-fit: cover;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
      }

      .name {
        padding: 2vw;
        font-family: Regular;
        text-align: center;
        background: #fff;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;

        p {
          opacity: 1;
          font-size: 2.1rem;
          transition: all 0.3s;
        }
      }
    }

    .item:hover {
      transition: all 0.3s;

      .zhezhao {
        transition: all 0.3s;
        opacity: 1;
        display: flex;

        .item:hover {
          color: #024580;
          font-family: Demibold;
        }

        .item.disabled:hover {
          color: #72717180;
          font-family: Regular;
          cursor: not-allowed;
        }

        .title.disabled:hover {
          color: #72717180;
          cursor: not-allowed;
        }
      }

      .name {
        p {
          transition: all 0.3s;
          opacity: 0;
        }
      }
    }
  }
}

/deep/ .el-tree-node__label {
  font-size: 1.7rem;
}

// /deep/ .el-tree-node__content{
// margin:0.5rem 0;
// }
.father_div_bg {
  padding: 0 20rem;
  border-radius: 6px;
  height: 100%;
}

.p_disabled{
  cursor: not-allowed ;
  font-size:1.7rem;
}

.p_abled{
  cursor:pointer;
  font-size:1.7rem;
}
.p_abled:hover{
  cursor:pointer;
  font-size:1.7rem;
  color:var(--mainBlue);
  font-family:Demibold;
}

@media screen and (max-width: 1400px) {
  .father_div_bg {
    padding: 0 1rem;
  }
}
@media screen and (max-width: 1000px) {
  
  .selectbox{
    margin-top:-4vh;
  }
  .show_pc {
    display: none;
  }
  .show_phone {
    display: block;
  }
  .product-menu .left{
    margin-top:0;
    padding-right: 0 !important;
  }
  .product-menu .right{
    margin-top:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/Product.vue